// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  --padding-top: 7px !important;
  --padding-end: 8px !important;
  --padding-bottom: 7px !important;
  border: none;
  height: 35px;
}

.input-container {
  height: 45px;
  display: flex;
  align-items: center;
  border: 1px solid var(--ion-color-primary);
  border-radius: 8px;
  padding: 10px;
}

.input-container ion-input {
  flex: 1;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/DNA/show-dna.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,6BAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF","sourcesContent":[".input {\n  --padding-top: 7px !important;\n  --padding-end: 8px !important;\n  --padding-bottom: 7px !important;\n  border: none;\n  height: 35px;\n}\n\n.input-container {\n  height: 45px;\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.input-container ion-input {\n  flex: 1;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
